module.exports = __webpack_public_path__ + "media/SetA_T5_B.84c108a7.mp3";